import { Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { QueryFetcher } from '@app/models/core/query-fetcher.model';
import { ApplicantInterviewers } from '@app/models/recruiting/applicant-interviewers.model';
import { MyInterviewers } from '@app/models/recruiting/my-interview.model';
import { Table } from '@app/modules/table/classes/table.class';
import { ApplicantColumn } from './columns/applicant.column';
import { FeedbackDueBy } from './columns/feedback-due-by.column';
import { InterviewColumn } from './columns/interview.column';
import { JobPositionColumn } from './columns/job-position.column';
import { Status } from './columns/status.column';

@Injectable()
export class InterviewIndexTable extends Table {
    links = true;
    showMenuColumnOptions = true;

    constructor() {
        super();
        this.boot();
    }

    getLink(applicantInterviewer: ApplicantInterviewers): (string | number)[] {
        return applicantInterviewer.isSubmitted
            ? [
                  '/recruiting',
                  'jobPostings',
                  applicantInterviewer.applicantInterview.interview.atsJobId,
                  'interviews',
                  'applicantInterviews',
                  applicantInterviewer.applicantInterview.id,
              ]
            : ['./manage', applicantInterviewer.applicantInterview.id];
    }

    setColumns(): void {
        this.addColumns(
            new InterviewColumn(),
            new ApplicantColumn(),
            new JobPositionColumn(),
            new FeedbackDueBy(),
            new Status()
        );
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            MyInterviewers.with([
                'applicantInterview',
                'applicantInterview.interview',
                'applicantInterview.applicant',
                'applicantInterview.applicant.jobPosting',
                'applicantInterviewerFeedbacks',
            ]) as QueryFetcher<MyInterviewers>
        );
    }
}
